import { ApprovalInstructionKindForMultipleValueResources } from './constants';

export const getAddReviewersSemanticPatchInstructions = (notifyMemberIds?: string[], notifyTeamKeys?: string[]) => [
  {
    kind: ApprovalInstructionKindForMultipleValueResources.ADD_REVIEWERS,
    notifyMemberIds,
    notifyTeamKeys,
  },
];
